export class ExamList {
    constructor() {
        this.exams = [];
    }
    add(exam) {
        this.exams.push(exam);
    }
    clear() {
        this.exams = [];
    }
    addAll(exam) {
        exam.forEach((exam) => this.add(exam));
    }
    getNameCommaSeparated() {
        if (this.exams.length == 0) {
            return allExamsMessage;
        }
        const examNames = [];
        this.exams.forEach((exam) => {
            examNames.push(exam.name);
        });
        return examNames.join(", ");
    }
    getIdsArray() {
        const ids = [];
        this.exams.forEach((exam) => {
            ids.push(exam.id);
        });
        return ids;
    }
}
